var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var toMediaQuery = function (minWidth, styles) {
    var _a;
    return _a = {},
        _a["@media (min-width: " + minWidth + "px)"] = __assign({}, styles),
        _a;
};
export var toMaxMediaQuery = function (maxWidth, styles) {
    var _a;
    return _a = {},
        _a["@media (max-width: " + maxWidth + "px)"] = __assign({}, styles),
        _a;
};
function carinaFontReset(theme) {
    return {
        fontFamily: theme.font.base.family,
        fontStyle: 'normal',
        fontWeight: theme.font.base.weight.regular,
        letterSpacing: 'normal',
        lineHeight: theme.font.lineHeight.base,
        textIndent: 0,
        textShadow: 'none',
        textTransform: 'none'
    };
}
export { carinaFontReset };
